// extracted by mini-css-extract-plugin
export default {"expandedInfo-description":"bts_expandedInfo-description__jIw0N","open-btn":"bts_open-btn__bbJBc","pending-btn":"bts_pending-btn__FPQO3","done-btn":"bts_done-btn__ZwdJx"};